import { render, staticRenderFns } from "./OrganizationCreateContainer.vue?vue&type=template&id=32c237eb&scoped=true"
import script from "./OrganizationCreateContainer.vue?vue&type=script&lang=js"
export * from "./OrganizationCreateContainer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCreateContainer.vue?vue&type=style&index=0&id=32c237eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c237eb",
  null
  
)

export default component.exports